import React, { useState, useEffect } from 'react';
import { listUrls, deleteUrl } from '../api';
import { QRCodeSVG } from 'qrcode.react';

function UrlList() {
  const [urls, setUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    pages: 0,
  });

  useEffect(() => {
    fetchUrls();
  }, [pagination.page]);

  const fetchUrls = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await listUrls(pagination.page, pagination.limit);
      setUrls(response.data.data);
      setPagination(response.data.pagination);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch URLs');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (shortCode) => {
    if (!window.confirm('Are you sure you want to delete this URL?')) {
      return;
    }

    try {
      await deleteUrl(shortCode);
      fetchUrls();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete URL');
    }
  };

  const handleViewAnalytics = (shortCode) => {
    window.location.hash = `#analytics/${shortCode}`;
  };

  const handleCopyUrl = (shortUrl) => {
    navigator.clipboard.writeText(shortUrl);
    alert('Short URL copied to clipboard!');
  };

  const getShortUrl = (shortCode) => {
    const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
    return `${baseUrl}/${shortCode}`;
  };

  if (loading) {
    return <div className="loading">Loading URLs...</div>;
  }

  return (
    <div className="card">
      <h2>Your URLs</h2>

      {error && <div className="error">{error}</div>}

      {urls.length === 0 ? (
        <p style={{ textAlign: 'center', padding: '40px', color: '#7f8c8d' }}>
          No URLs created yet. Create your first short URL!
        </p>
      ) : (
        <>
          <ul className="url-list">
            {urls.map((url) => {
              const shortUrl = getShortUrl(url.shortCode);
              return (
                <li key={url._id} className="url-item">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flex: 1 }}>
                    <div style={{ flexShrink: 0 }}>
                      {url.qrCode ? (
                        <img 
                          src={url.qrCode} 
                          alt="QR Code" 
                          style={{ 
                            width: '80px', 
                            height: '80px', 
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '5px',
                            background: 'white'
                          }} 
                        />
                      ) : (
                        <QRCodeSVG
                          value={shortUrl}
                          size={80}
                          level="M"
                          style={{ 
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '5px'
                          }}
                        />
                      )}
                    </div>
                    <div className="url-item-info" style={{ flex: 1 }}>
                      <h4>{url.title || url.shortCode}</h4>
                      <p style={{ color: '#3498db', cursor: 'pointer', marginTop: '5px' }} onClick={() => handleCopyUrl(shortUrl)}>
                        <strong>Short URL:</strong> {shortUrl} 📋
                      </p>
                      <p style={{ fontSize: '0.9rem', marginTop: '5px' }}>
                        <strong>Original:</strong> {url.originalUrl}
                      </p>
                      <p style={{ fontSize: '0.8rem', marginTop: '5px', color: '#7f8c8d' }}>
                        Created: {new Date(url.createdAt).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                  <div className="url-item-stats">
                    <p><strong>{url.totalClicks}</strong></p>
                    <p style={{ fontSize: '0.8rem' }}>clicks</p>
                  </div>
                  <div className="url-item-actions">
                    <button
                      onClick={() => handleViewAnalytics(url.shortCode)}
                      className="btn"
                    >
                      Analytics
                    </button>
                    {/* Delete button disabled for security */}
                    {/* <button
                      onClick={() => handleDelete(url.shortCode)}
                      className="btn btn-secondary"
                    >
                      Delete
                    </button> */}
                  </div>
                </li>
              );
            })}
          </ul>

          {pagination.pages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })}
                disabled={pagination.page === 1}
              >
                Previous
              </button>
              <span>
                Page {pagination.page} of {pagination.pages}
              </span>
              <button
                onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })}
                disabled={pagination.page === pagination.pages}
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default UrlList;
